import User from "../models/User";

type CustomData = Record<string, any>

export default class LoggerService {
	/**
	 * Additional field used to log info about user
	 * @private
	 */
	private static loggerUser: User | undefined;

	public static setLoggerUser(user: User | undefined) {
		LoggerService.loggerUser = user
	}

	public static logError(err: any, customData?: CustomData) {
		const getCustomData = function(): CustomData {
			const defaultData: CustomData = {
				userId: LoggerService.loggerUser?.userId,
				companyId: LoggerService.loggerUser?.companyId
			}
			const responseData = err?.response?.data
			const axiosData: CustomData = responseData ? {
				httpStatus: err.response.status,
				apiException: responseData.exception,
				apiMessage: responseData.message,
				apiPath: responseData.path
			} : {}
			return {...defaultData, ...axiosData, ...(customData ?? {})};
		}

		if (window.rg4js) {
			window.rg4js("send", {
				error: err,
				customData: getCustomData()
			})
		}
		console.error(err)
	}
}